import { useEffect, useState } from 'react';
import { headlineTicker, siteStats } from '@/mocks/gossip';

export default function UpdateBar() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % headlineTicker.length);
    }, 3800);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="sticky top-0 z-50 bg-foreground-950 text-background-50">
      <div className="mx-auto flex h-11 max-w-[1280px] items-center gap-3 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5">
          <span className="live-dot h-2 w-2 rounded-full bg-accent-400" />
          <span className="font-label text-[11px] font-medium tracking-[0.2em] text-accent-300">实时更新</span>
        </span>
        <span className="hidden h-4 w-px bg-background-50/20 sm:block" />
        <div className="relative h-5 flex-1 overflow-hidden">
          <div key={index} className="absolute inset-0 flex items-center animate-[fadeUp_0.5s_ease]">
            <span className="truncate text-xs text-background-100/90">{headlineTicker[index]}</span>
          </div>
        </div>
        <span className="hidden shrink-0 items-center gap-2 text-[11px] text-background-50/60 md:flex">
          <span>
            今日已更新 <span className="font-semibold text-accent-300">{siteStats.todayUpdates}</span> 条
          </span>
          <span className="text-background-50/30">|</span>
          <span>最后更新 {siteStats.lastUpdate}</span>
        </span>
      </div>
    </div>
  );
}